<template>
  <div>
    <table class="custom-table responsive-table border-collapse">
      <thead v-if="activeTab == 'active'" class="font-normal">
        <tr class="shadow-table rounded-lg">
          <th class="checkbox">
            <base-checkbox />
          </th>
          <th v-for="header in activeHeaderFilter" :key="header">{{ header.name || "" }}</th>
          <th tabindex="-1">
            <span @click="showFilterModal = true" class="cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg></span>
          </th>
        </tr>
      </thead>
      <thead v-if="activeTab == 'quote'" class="font-normal">
        <tr class="shadow-table rounded-lg">
          <th class="checkbox">
            <base-checkbox />
          </th>
          <!-- <th >Trans Date</th> -->
          <th v-for="header in activeQuoteFilter" :key="'quote' + header.name">{{ header.name || '' }}</th>
          <th tabindex="-1">
            <span @click="showFilterModal = true" class="cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg></span>
          </th>
        </tr>
      </thead>
      <thead v-if="activeTab == 'payment'" class="font-normal">
        <tr class="shadow-table rounded-lg">
          <th class="checkbox">
            <base-checkbox />
          </th>
          <!-- <th >Trans Date</th> -->
          <th v-for="header in activePaymentFilter" :key="'paymane' + header">{{ header.name || '' }}</th>
          <th tabindex="-1">
            <span @click="showFilterModal = true" class="cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg></span>
          </th>
        </tr>
      </thead>
      <thead v-if="activeTab == 'recievable'" class="font-normal">
        <tr class="shadow-table rounded-lg">
          <th class="checkbox">
            <base-checkbox />
          </th>
          <!-- <th >Trans Date</th> -->
          <th v-for="header in activeRecievableFilter" :key="'recievables' + header">{{ header.name || '' }}</th>
          <th tabindex="-1">
            <span @click="showFilterModal = true" class="cursor-pointer">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.7">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51" />
                </g>
              </svg></span>
          </th>
        </tr>
      </thead>
      <tbody v-if="activeTab == 'active'">
        <tr v-for="trans in allTableContent" :key="trans.id" class="shadow-table rounded-lg">
          <td>
            <base-checkbox />
          </td>
          <td v-for="(header, index) in activeHeaderFilter" :key="'active-reg' + index">
            <!-- Special case for Status -->
            <span v-if="header.name === 'Shipping Status'" :class="getStatusClass(trans.deliveryStatus)">
              {{ trans.deliveryStatus || 'N/A' }}
            </span>
            <!-- Special case for estimated weight -->
            <span v-else-if="header.name === 'Gross Weight'">
              {{ totalpackageWeight(trans.packagees) || 'N/A' }}
            </span>

            <!-- Special case for Route -->
            <span v-else-if="header.name === 'Route'">
              {{ trans.shipperlocation && trans.shipperlocation.address ? trans.shipperlocation.address.state : 'N/A' }}{{
                 trans.consigneelocation &&  trans.consigneelocation.address ?  `-${trans.consigneelocation.address.state}` : 'N/A' 
                }}
            </span>

            
            <!-- Special case for Transaction Date -->
            <span v-else-if="header.name === 'Transaction Date'">
              {{ trans.createdAt ? trans.createdAt.split("T")[0] : "N/A" }}
              <span class="block w-full opacity-50">{{ trans.createdAt ? trans.createdAt.split("T")[1].split(".")[0] :
                "" }}</span>
            </span>
            <!-- Special case for Transaction Date -->
            <span v-else-if="header.name === 'Total Shipping Cost (N)'">
              {{ getActiveTotalcost(trans) || 'N/A' }}
            </span>
            <!-- Default case for other headers -->
            <span v-else>
              {{ getNestedValue(trans, header.path) }}
            </span>
          </td>
          <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer relative">
            <span class="-full flex justify-center" @click="selectedRowId = trans.id">
              <vertical-ellipsis />
            </span>

            <div class="actions" v-if="selectedRowId == trans.id">
              <div class="cursor-pointer hover:bg-gray-100" @click="transactionRoute(trans.transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/icon-eye-alt.svg" /></span>
                <span>View</span>
              </div>
              <div v-if="!isPaid(trans)" class="cursor-pointer hover:bg-gray-100"
                @click="invoiceRoute(trans.transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/send_invoice.svg" /></span>
                <span>Send Invoice</span>
              </div>
              <div v-if="!isPaid(trans)" class="cursor-pointer hover:bg-gray-100"
                @click="collectPaymentModalFunc(trans)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/collectPayment.svg" /></span>
                <span>Collect Payment</span>
              </div>
              <div v-if="!isPaid(trans)" class="cursor-pointer hover:bg-gray-100" @click="sharelinkModalFunc(trans)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/sharepaylink.svg" /></span>
                <span>Share Pay Link</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody v-if="activeTab == 'quote'">
        <tr v-for="trans in allTableContent" :key="trans.id + 'quote'" class="shadow-table rounded-lg">
          <td>
            <base-checkbox />
          </td>
          <td v-for="header in activeQuoteFilter" :key="header + 'quote'">
            <!-- Special case for estimated weight -->
            <span v-if="header.name === 'Gross Weight'">
              {{ totalpackageWeight(trans.packagees) || 'N/A' }}
            </span>
            <!-- Default case for other headers -->
            <span v-else>
              {{ getNestedValue(trans, header.path) }}
            </span>
            <!-- {{ getNestedValue(trans, headerMap[header.name]) }} -->
          </td>
          <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer relative">
            <span class="-full flex justify-center" @click="selectedRowId = trans.id">
              <vertical-ellipsis />
            </span>

            <div class="actions" v-if="selectedRowId == trans.id">
              <div class="cursor-pointer hover:bg-gray-100" @click="transactionRoute(trans.transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/icon-eye-alt.svg" /></span>
                <span>View</span>
              </div>
              <div class="cursor-pointer hover:bg-gray-100" @click="updateToBooking(trans)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/update.svg" /></span>
                <span>Update</span>
              </div>
              <div class="cursor-pointer hover:bg-gray-100" @click="sendQuoteRoute(trans.transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/send_invoice.svg" /></span>
                <span>Send Quote</span>
              </div>
              <div class="cursor-pointer hover:bg-gray-100" @click="deleteQuote(trans)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/delete.svg" /></span>
                <span>Delete</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody v-if="activeTab == 'payment'">
        <tr v-for="trans in allTableContent" :key="trans.id + 'payment'" class="shadow-table rounded-lg">
          <td>
            <base-checkbox />
          </td>
          <td v-for="header in activePaymentFilter" :key="header.name + 'payment'">
            <!-- Special case for estimated weight -->
            <span v-if="header.name === 'Gross Weight'">
              {{ totalpackageWeight(trans.packagees) || 'N/A' }}
            </span>
            <!-- Special case for payment Date -->
            <span v-else-if="header.name === 'Payment Date'">
              {{ returnDate(trans.createdAt) || 'N/A' }}
            </span>

              <!-- Special case for Route -->
            <span v-else-if="header.name === 'Route'">
              {{ trans.shipperlocation && trans.shipperlocation.address ? trans.shipperlocation.address.state : 'N/A' }}{{
                 trans.consigneelocation &&  trans.consigneelocation.address ?  `-${trans.consigneelocation.address.state}` : 'N/A' 
                }}
            </span>

            <!-- Default case for other headers -->
            <span v-else>
              {{ getNestedValue(trans, header.path) }}
            </span>
            <!-- {{ getNestedValue(trans, headerMap[header.name]) }} -->
          </td>
          <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer relative">
            <span class="-full flex justify-center" @click="selectedRowId = trans.id">
              <vertical-ellipsis />
            </span>

            <div class="actions" v-if="selectedRowId == trans.id">
              <div class="cursor-pointer hover:bg-gray-100" @click="transactionRoute(trans.transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/icon-eye-alt.svg" /></span>
                <span>View</span>
              </div>
              <div class="cursor-pointer hover:bg-gray-100" @click="recieptRoute(trans.transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/send_invoice.svg" /></span>
                <span>Send Reciept</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="activeTab == 'recievable'">
        <tr v-for="trans in allTableContent" :key="trans.id + 'quote'" class="shadow-table rounded-lg">
          <td>
            <base-checkbox />
          </td>
          <td v-for="header in activeRecievableFilter" :key="header + 'payment'">
            <!-- Special case for Status -->
            <!-- Special case for estimated weight -->
            <span v-if="header.name === 'Gross Weight'">
              {{ totalpackageWeight(trans.packagees) || 'N/A' }}
            </span>
            <span v-if="header.name === 'Status'" :class="getStatusClass(trans.deliveryStatus)">
              {{ trans.deliveryStatus }}
            </span>
            <!-- Default case for other headers -->
            <span v-else>
              {{ getNestedValue(trans, header.path) }}
            </span>
            <!-- {{ getNestedValue(trans, headerMap[header.name]) }} -->
          </td>
          <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer relative">
            <span class="-full flex justify-center" @click="selectedRowId = trans.id">
              <vertical-ellipsis />
            </span>

            <div class="actions" v-if="selectedRowId == trans.id">
              <div class="cursor-pointer hover:bg-gray-100" @click="transactionRoute(trans.transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/icon-eye-alt.svg" /></span>
                <span>View</span>
              </div>
              <div class="cursor-pointer hover:bg-gray-100" @click="invoiceRoute(trans.transaction.id)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/send_invoice.svg" /></span>
                <span>Send Invoice</span>
              </div>
              <div class="cursor-pointer hover:bg-gray-100" @click="collectPaymentModalFunc(trans)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/collectPayment.svg" /></span>
                <span>Collect Payment</span>
              </div>
              <div class="cursor-pointer hover:bg-gray-100" @click="sharelinkModalFunc(trans)">
                <span class="icon"><img alt="" class="mr-1" src="@/assets/images/billing/sharepaylink.svg" /></span>
                <span>Share Pay Link</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <EmptyContent v-if="!allTableContent.length" />
    <TableheaderFilter :show-modal="showFilterModal" :activeHeaders="selectedRegister"
      :resetPropsFromFilter="resetPropsFromFilter" @close-modal="showFilterModal = false" />
    <CollectPayment :shippingId="shippingId" :transactionId="transactionId" :totalCost="totalCost"
      :show-modal="collectPaymentModal" @refetch-transactions="$emit('refetch-transactions')"
      @close-modal="collectPaymentModal = false" />
    <SharePayLink :paymentParams="paymentParams" :shippingId="shippingId" :transactionId="transactionId"
      :show-modal="shareLinkModal" @close-modal="shareLinkModal = false" />
  </div>
</template>

<script>
import TableheaderFilter from "../modals/TableheaderFilter.vue";
import CollectPayment from "../modals/CollectPayment.vue";
import SharePayLink from "../modals/SharePayLink.vue";
import EmptyContent from "../svg/EmptyContent.vue";
import moment from "moment";


export default {
  props: ["tableContent", 'activeTab', 'refetchTransactions', "currentTab"],
  components: {
    TableheaderFilter,
    CollectPayment,
    SharePayLink,
    EmptyContent,
  },
  data() {
    return {
      showFilterModal: false,
      collectPaymentModal: false,
      shareLinkModal: false,
      selectedRowId: -1,
      totalCost: 0,
      transactionId: null,
      shippingId: "",
      paylink: "",
      email: "",
      payAmount: "",
      activeHeaders: [
        { name: "Shipping ID", active: true, path: 'shippingReference' },
        { name: "Route", active: true, path: 'shippingservice.routeName' },
        { name: "Category", active: true, path: 'shippingMethod' },
        { name: "Origin", active: false, path: 'shipperlocation.address.name' },
        { name: "Destination", active: true, path: 'consigneelocation.address.name' },
        { name: "Gross Weight", active: true, path: '' },
        { name: "Customer", active: false, path: 'shipperlocation.contactName' },
        { name: "Total Shipping Cost (N)", active: true, path: 'transaction.breakDown.totalCost' },
        { name: "Payment Status", active: false, path: 'transaction.status' },
        { name: "Shipping Status", active: true, path: 'status' },
      ],
      quoteHeaders: [
        { name: "Shipping ID", active: true, path: 'shippingReference' },
        { name: "Route", active: true, path: 'shippingservice.routeName' },
        { name: "Category", active: true, path: 'shippingservice.terminalType' },
        { name: "Customer", active: false, path: 'shipperlocation.contactName' },
        { name: "Origin", active: true, path: 'shipperlocation.address.name' },
        { name: "Destination", active: true, path: 'consigneelocation.address.name' },
        { name: "Gross Weight", active: true, path: '' },
        { name: "Total Shipping Cost", active: true, path: 'transaction.totalValue' },
        { name: "Status", active: false, path: 'status' },
      ],
      paymentHeaders: [
        { name: "Shipping ID", active: true, path: 'shippingReference' },
        { name: "Route", active: true, path: 'shippingservice.routeName' },
        { name: "Category", active: true, path: 'shippingMethod' },
        { name: "Origin", active: false, path: 'shipperlocation.address.name' },
        { name: "Destination", active: false, path: 'consigneelocation.address.name' },
        { name: "Gross Weight", active: true, path: '' },
        { name: "Total Shipping Cost (N)", active: true, path: 'transaction.totalValue' },
        { name: "Mode of Payment", active: true, path: 'transaction.payment_type' },
        { name: "Payment Date", active: true, path: 'createdAt' },
        { name: "Payment Status", active: false, path: 'transaction.status' },
      ],
      recievablesHeaders: [
        { name: "Shipping ID", active: true, path: 'shippingReference' },
        { name: "Route", active: true, path: 'shippingservice.routeName' },
        { name: "Category", active: true, path: 'shippingservice.terminalType' },
        { name: "Origin", active: false, path: 'shipperlocation.address.name' },
        { name: "Destination", active: false, path: 'consigneelocation.address.name' },
        { name: "Gross Weight", active: true, path: '' },
        { name: "Total Shipping Cost", active: true, path: 'shippingReference' },
        { name: "Ageing (Days)", active: true, path: 'transaction.totalValue' },
        { name: "Status", active: true, path: 'status' },
      ],
    };
  },
  computed: {
    selectedRegister() {
      switch (this.activeTab) {
        case 'active':
          return this.activeHeaders
        case 'quote':
          return this.quoteHeaders
        case 'payment':
          return this.paymentHeaders
        case 'recievable':
          return this.recievablesHeaders
        default:
          return this.activeHeaders
      }
    },
    activeHeaderFilter() {
      return this.activeHeaders.filter((item) => item.active)
    },
    activeQuoteFilter() {
      return this.quoteHeaders.filter((item) => item.active)
    },
    activePaymentFilter() {
      return this.paymentHeaders.filter((item) => item.active)
    },
    activeRecievableFilter() {
      return this.recievablesHeaders.filter((item) => item.active)
    },
    allTableContent() {
      return this.tableContent;
    },
    paymentParams() {
      return {
        email: this.email,
        payAmount: this.payAmount,
        shippingId: this.shippingId
      };
    },
  },
  methods: {
    getActiveTotalcost(shipping) {
      let cost = this.currentTab === 'private' ? shipping.transaction?.totalValue : shipping.transaction?.breakDown?.totalCost
      return new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: 'NGN',
      }).format(cost)
    },
    resetPropsFromFilter(val) {
      switch (this.activeTab) {
        case 'active':
          this.activeHeaders = this.activeHeaders.map((item, index) => {
            return { ...item, ...val[index] }
          })
          break;
        case 'quote':
          this.quoteHeaders = this.quoteHeaders.map((item, index) => {
            return { ...item, ...val[index] }
          })
          break;
        case 'payment':
          this.paymentHeaders = this.paymentHeaders.map((item, index) => {
            return { ...item, ...val[index] }
          })
          break;
        case 'recievable':
          this.recievablesHeaders = this.recievablesHeaders.map((item, index) => {
            return { ...item, ...val[index] }
          })
          break;
      }
    },
    async deleteQuote(trans) {
      await this.$_deleteQuote3pl(trans.id)
      this.$emit('refetchTransactions')
    },
    handleTakeoffActions(booking) {
      const shipper = { ...booking.shipperlocation };
      delete shipper.userId;
      delete shipper.updatedAt;
      delete shipper.createdAt;
      delete shipper.id;
      this.$store.dispatch("saveBookingInformation", {
        property: "shipper",
        value: shipper,
      });
      this.$store.dispatch(
        "saveSelectedShipperLocation",
        booking.shipperlocation
      );
      this.$store.dispatch("saveTakeOffLocationId", booking.id);
      this.$store.dispatch("saveLastCompletedFormNo", 0);
      this.$router.push({ name: "NewBooking" });
    },
    updateToBooking(booking) {
      this.handleTakeoffActions(booking)
      this.$store.dispatch("setSavedQuote3pl", booking);
    },
    isPaid(booking) {
      return booking?.transaction?.paymentStatus == 'paid'
    },
    returnDate(val) {
      return moment(val).format('YYYY-MM-DD')
    },
    // getNestedValue(obj, path) {
    //   // Split the path into an array (e.g., 'customer.name' -> ['customer', 'name'])
    //   return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    // },
    getNestedValue(obj, path) {
      // Split the path into an array (e.g., 'customer.name' -> ['customer', 'name'])
      const value = path.split('.').reduce((acc, part) => acc && acc[part], obj);
      // Return 'N/A' if the value is missing (null, undefined, or empty string)
      return value === null || value === undefined || value === '' ? 'N/A' : value;
    },
    totalpackageWeight(packagees) {
      if (!packagees.length) return "0";
      return packagees
        .map((item) => Number(item.estimatedWeight))
        .reduce((prev, next) => prev + next);
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    getStatusClass(status) {
      // Return a CSS class based on the status value
      return {
        'status-paid': status === 'paid',
        'status-pending': status === 'pending',
        'status-unpaid': status === 'unpaid'
      };
    },
    transactionRoute(val) {
      if (!val) return;
      this.$router.push({ name: "Transaction_View", params: { id: val } });
    },
    collectPaymentModalFunc(val) {
      this.totalCost = val?.transaction?.totalValue;
      this.transactionId = val?.transaction?.id;
      this.shippingId = val?.id;
      this.collectPaymentModal = true;
    },
    sharelinkModalFunc(val) {
      this.payAmount = val?.transaction?.totalValue;
      this.email = val?.user?.email;
      this.shippingId = val?.id;
      this.transactionId = val?.transaction?.id;
      this.shareLinkModal = true;
    },
    sendQuoteRoute(val) {
      if (!val) return;
      this.$router.push({ name: "BCM_Send_Quote", params: { id: val } });
    },
    invoiceRoute(val) {
      if (!val) return;
      this.$router.push({ name: "BCM_invoice", params: { id: val } });
    },
    recieptRoute(val) {
      if (!val) return;
      this.$router.push({ name: "BCM_Billreciept", params: { id: val } });
    }
    // getRouteName(val) {
    //   return val?.shippingservice?.routeName || "N/A";
    // },

    // getshippingReference(val) {
    //   return val?.shippingservice?.routeName || "N/A";
    // },
    // getStatus(val) {
    //   return val?.status || "pending";
    // },
    // totalShippingCost(val) {
    //   return val?.totalValue?.toLocaleString() || "N/A";
    // },
    // statusBg(val) {
    //   let bg = "";
    //   switch (val) {
    //     case "pending":
    //       bg = "text-red-500";
    //       break;

    //     case "estimate":
    //       bg = "text-primary-yellow";
    //       break;

    //     default:
    //       bg = "text-teal-500";
    //       break;
    //   }
    //   return bg;
    // },
  },
};
</script>

<style lang="scss" scoped>
.status-paid {
  color: rgb(38, 194, 38);
}

.status-pending {
  color: red;
}

.status-unpaid {
  color: yellow;
}

.actions {
  @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
  min-width: 200px;
}

.actions div {
  @apply flex w-full py-2 px-2 items-center;
}

.icon {
  width: auto;
  padding-right: 5px;
}
</style>
